import { render } from "./BioIntelligentPart7.vue?vue&type=template&id=a54518d8&scoped=true"
import script from "./BioIntelligentPart7.vue?vue&type=script&lang=js"
export * from "./BioIntelligentPart7.vue?vue&type=script&lang=js"

import "./BioIntelligentPart7.vue?vue&type=style&index=0&id=a54518d8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54518d8"]])

export default __exports__